import React from 'react';
import PropTypes from 'prop-types';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const PerformanceExpressRow = ({ level, levelTitle, performance }) => (
    <div key={level} className={`${level} column`}>
        <div className="perfomance-cell interp">{levelTitle}</div>
        {performance.map(({ isAvailible, value }, index) => {
            let studentPerfomanceView = <span className="students-info-express">{value}</span>;

            if (isAvailible) {
                const { studentsTotalNumber, percentage } = value;
                const studentsText = studentsTotalNumber === 1 ? ' Student' : ' Students';
                studentPerfomanceView = (
                    <>
                        <span className="students-info-express">
                            {percentage}
                            <span className="percentage">%</span>
                        </span>
                        <span className="students-number">
                            {studentsTotalNumber}
                            <span className="students-text">{studentsText}</span>
                        </span>
                    </>
                );
            }

            return (
                <div key={generateReactKey(index)} className="perfomance-cell">
                    <div className="students-info-container">{studentPerfomanceView}</div>
                    <div className={`${performance.length !== index + 1 && 'line'}`} />
                </div>
            );
        })}
    </div>
);

PerformanceExpressRow.defaultProps = {
    levelTitle: '',
    performance: [],
    level: '',
};

PerformanceExpressRow.propTypes = {
    levelTitle: PropTypes.string,
    performance: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
    level: PropTypes.string,
};

export default PerformanceExpressRow;
